type MainLayoutSidenavButtonProps = {
  isActive: boolean;
  isExpanded: boolean;
  icon: () => JSX.Element;
  title: string;
  onClick: () => any;
};

const MainLayoutSidenavButton = ({
  isActive,
  isExpanded,
  icon,
  title,
  onClick,
}: MainLayoutSidenavButtonProps) => {
  const generateButtonText = () => {
    if (isExpanded) {
      return <div className="c-sidenav-button__expanded-text">{title}</div>;
    }
  };

  const generateButton = () => {
    return (
      <div
        className={"c-sidenav-button" + (isExpanded ? " --expanded" : "")}
        onClick={() => onClick()}
      >
        <div
          title={title} className={"c-sidenav-button__icon" + (isActive ? " --active" : "")}
        >
          {icon()}
        </div>
        {generateButtonText()}
      </div>
    );
  };

  return generateButton();
};

export default MainLayoutSidenavButton;
